/**
 * 공유 로그인 유틸리티 - shared-auth-core 통합 버전
 * 
 * 🚀 DRY 원칙 적용: 이제 모든 앱이 @edusense/shared-auth-core의 공통 함수 사용
 * 
 * @deprecated 직접 @edusense/shared-auth-core에서 startGeminiLogin 사용 권장
 */

import { handleSharedOAuthLogin as coreHandleSharedOAuthLogin } from '@edusense/shared-auth-core';

/**
 * OAuth 로그인 핸들러 - 공통 라이브러리 래퍼
 * HomePage의 AuthActions와 HeaderActions에서 공통으로 사용
 * 
 * @deprecated 직접 import { startOAuthLogin } from '@edusense/shared-auth-core' 사용 권장
 */
export const handleSharedOAuthLogin = async (currentLang: string) => {
  console.log('[SharedLogin-Wrapper] 🔄 공통 라이브러리로 이동:', currentLang);
  
  // shared-auth-core의 공통 함수로 완전히 위임
  return coreHandleSharedOAuthLogin(currentLang);
};

/**
 * 기존 Gemini 이름 호환성 유지 (곧 제거 예정)
 * 
 * @deprecated handleSharedOAuthLogin 사용 권장
 */
export const handleSharedGeminiLogin = handleSharedOAuthLogin;